// extracted by mini-css-extract-plugin
export const binarySystem = "binarySystem-module--binarySystem--3gOR6";
export const blueGiant = "binarySystem-module--blueGiant--2BZnm";
export const yellowGiant = "binarySystem-module--yellowGiant--19uCV";